import React from 'react';

import StaticPageComponent from './StaticPage';

export const StaticPage = StaticPageComponent;
export const Cgv = () => <StaticPageComponent pageId="cgv" />;
export const Faq = () => <StaticPageComponent pageId="faq" />;
export const About = () => <StaticPageComponent pageId="about" />;
